import React from 'react';
import { Helmet } from 'react-helmet-async';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Layout from './components/Layout';
import Home from './pages/Home';
import VanLife from './pages/VanLife';
import Contact from './pages/Contact';
import VanBooking from './pages/VanBooking';
import ScrollToTop from './components/ScrollToTop';
import CookieConsent from './components/cookies';
import CGU from './pages/CGU';
import MentionsLegales from './pages/MentionsLeg';
import PolitiqueConfidentialite from './pages/PolitiqueConf';
import PolitiqueCookies from './pages/PolitiqueCookies';
import About from './pages/About';
import FAQ from './pages/FAQ';
import NotFound from './pages/NotFound';

function App() {
  return (
    <>
      <Helmet>
        <title>To The Road — Location de vans aménagés à Versailles</title>
        <meta
          name="description"
          content="TO THE ROAD, loueur de vans aménagés basé à Versailles. Volkswagen California, ID. Buzz — réservez sur Wikicampers, Yescapa, Getaround."
        />
      </Helmet>
      <Router>
      <ScrollToTop />
      <Layout>
        <CookieConsent />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/van-life" element={<VanLife />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/reserver" element={<VanBooking/>} />
          <Route path="/reservation" element={<Navigate to="/reserver" replace />} />
          <Route path="/conditions-generales" element={<CGU />} />
          <Route path="/mentions-legales" element={<MentionsLegales />} />
          <Route path="/politique-confidentialite" element={<PolitiqueConfidentialite />} />
          <Route path="/cookies" element={<PolitiqueCookies />} />
          <Route path="/a-propos" element={<About />} />
          <Route path="/faq" element={<FAQ />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </Layout>
    </Router>
    </>
  );
}

export default App;
